"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Indi = exports.TextBlockType = exports.IndiProductsStatus = exports.IndiSubscriptionTypes = exports.MoonIntervalType = exports.MoonPhases = exports.PrognosisType = exports.IndiProductCode = exports.RecommendationType = exports.DayQuality = void 0;
var DayQuality;
(function (DayQuality) {
    DayQuality["LUCKY"] = "LUCKY";
    DayQuality["TYPICAL"] = "TYPICAL";
    DayQuality["BAD"] = "BAD";
})(DayQuality = exports.DayQuality || (exports.DayQuality = {}));
var RecommendationType;
(function (RecommendationType) {
    RecommendationType["TODO"] = "TODO";
    RecommendationType["NOTTODO"] = "NOTTODO";
    RecommendationType["PROMT"] = "PROMT";
})(RecommendationType = exports.RecommendationType || (exports.RecommendationType = {}));
var IndiProductCode;
(function (IndiProductCode) {
    IndiProductCode["SYNASTRY"] = "SYNASTRY";
    IndiProductCode["EMOTIONS"] = "EMOTIONS";
    IndiProductCode["SOLAR"] = "SOLAR";
    IndiProductCode["PERSON"] = "PERSON";
    IndiProductCode["SESSION"] = "SESSION";
})(IndiProductCode = exports.IndiProductCode || (exports.IndiProductCode = {}));
var PrognosisType;
(function (PrognosisType) {
    PrognosisType["DAY"] = "DAY";
    PrognosisType["TREND"] = "TREND";
    PrognosisType["MOON_PHASE"] = "MOON_PHASE";
    PrognosisType["SPECIAL_DAY"] = "SPECIAL_DAY";
    PrognosisType["MONTH"] = "MONTH";
    PrognosisType["DAY_FEED"] = "DAY_FEED";
    PrognosisType["MONTH_FEED"] = "MONTH_FEED";
})(PrognosisType = exports.PrognosisType || (exports.PrognosisType = {}));
var MoonPhases;
(function (MoonPhases) {
    MoonPhases["FULL"] = "FULL";
    MoonPhases["NEW"] = "NEW";
    MoonPhases["DECREASING"] = "DECREASING";
    MoonPhases["GROWING"] = "GROWING";
})(MoonPhases = exports.MoonPhases || (exports.MoonPhases = {}));
var MoonIntervalType;
(function (MoonIntervalType) {
    MoonIntervalType["IDLE"] = "IDLE";
    MoonIntervalType["NOTIDLE"] = "NOTIDLE";
    MoonIntervalType["NEW"] = "NEW";
    MoonIntervalType["FULL"] = "FULL";
    MoonIntervalType["HAIRCUT"] = "HAIRCUT";
})(MoonIntervalType = exports.MoonIntervalType || (exports.MoonIntervalType = {}));
var IndiSubscriptionTypes;
(function (IndiSubscriptionTypes) {
    IndiSubscriptionTypes[IndiSubscriptionTypes["MONTH"] = 1] = "MONTH";
    IndiSubscriptionTypes[IndiSubscriptionTypes["SIX_MONTH"] = 2] = "SIX_MONTH";
    IndiSubscriptionTypes[IndiSubscriptionTypes["YEAR"] = 3] = "YEAR";
    IndiSubscriptionTypes[IndiSubscriptionTypes["TRIAL"] = 10] = "TRIAL";
    IndiSubscriptionTypes[IndiSubscriptionTypes["CARDLESS_TRIAL"] = 20] = "CARDLESS_TRIAL";
})(IndiSubscriptionTypes = exports.IndiSubscriptionTypes || (exports.IndiSubscriptionTypes = {}));
var IndiProductsStatus;
(function (IndiProductsStatus) {
    IndiProductsStatus["UNPAID"] = "UNPAID";
    IndiProductsStatus["PAID"] = "PAID";
})(IndiProductsStatus = exports.IndiProductsStatus || (exports.IndiProductsStatus = {}));
var TextBlockType;
(function (TextBlockType) {
    TextBlockType["SIMPLE"] = "SIMPLE";
    TextBlockType["SPECIAL"] = "SPECIAL";
    TextBlockType["MARKED"] = "MARKED";
})(TextBlockType = exports.TextBlockType || (exports.TextBlockType = {}));
var Indi;
(function (Indi) {
    var SetPrognosesFeedback;
    (function (SetPrognosesFeedback) {
        var PrognosisType;
        (function (PrognosisType) {
            PrognosisType["DAY"] = "DAY";
            PrognosisType["TREND"] = "TREND";
            PrognosisType["MOON_PHASE"] = "MOON_PHASE";
            PrognosisType["SPECIAL_DAY"] = "SPECIAL_DAY";
            PrognosisType["MONTH"] = "MONTH";
            PrognosisType["DAY_FEED"] = "DAY_FEED";
            PrognosisType["MONTH_FEED"] = "MONTH_FEED";
        })(PrognosisType = SetPrognosesFeedback.PrognosisType || (SetPrognosesFeedback.PrognosisType = {}));
    })(SetPrognosesFeedback = Indi.SetPrognosesFeedback || (Indi.SetPrognosesFeedback = {}));
    var Events;
    (function (Events) {
        var Spheres;
        (function (Spheres) {
            Spheres["EMOTIONS"] = "emotions";
            Spheres["LOVE"] = "love";
            Spheres["COMMUNICATION"] = "communication";
            Spheres["CAREER"] = "career";
            Spheres["FINANCE"] = "finance";
            Spheres["HEALTH"] = "health";
            Spheres["TRAVEL"] = "travel";
            Spheres["IMPORTANT"] = "important";
        })(Spheres = Events.Spheres || (Events.Spheres = {}));
    })(Events = Indi.Events || (Indi.Events = {}));
    var GetMoon;
    (function (GetMoon) {
        var MoonPhase;
        (function (MoonPhase) {
            MoonPhase["FULL"] = "FULL";
            MoonPhase["NEW"] = "NEW";
            MoonPhase["DECREASING"] = "DECREASING";
            MoonPhase["GROWING"] = "GROWING";
        })(MoonPhase = GetMoon.MoonPhase || (GetMoon.MoonPhase = {}));
    })(GetMoon = Indi.GetMoon || (Indi.GetMoon = {}));
    var IndiUseOffer;
    (function (IndiUseOffer) {
        var Offers;
        (function (Offers) {
            Offers["FOURTEEN_FREE_DAYS"] = "FourteenFreeDays";
        })(Offers = IndiUseOffer.Offers || (IndiUseOffer.Offers = {}));
    })(IndiUseOffer = Indi.IndiUseOffer || (Indi.IndiUseOffer = {}));
    var GetAstroEvents;
    (function (GetAstroEvents) {
        var AstroEventsKey;
        (function (AstroEventsKey) {
            AstroEventsKey["MARS"] = "Mars";
            AstroEventsKey["MERCURY"] = "Mercury";
            AstroEventsKey["VENUS"] = "Venus";
            AstroEventsKey["SOLAR_ECLIPSE"] = "solarEclipse";
            AstroEventsKey["LUNAR_ECLIPSE"] = "lunarEclipse";
            AstroEventsKey["ECLIPSE_CORRIDOR"] = "eclipseCorridor";
        })(AstroEventsKey = GetAstroEvents.AstroEventsKey || (GetAstroEvents.AstroEventsKey = {}));
    })(GetAstroEvents = Indi.GetAstroEvents || (Indi.GetAstroEvents = {}));
    var IndiBanners;
    (function (IndiBanners) {
        var BannersId;
        (function (BannersId) {
            BannersId["EVENT_DIAGNOSTIC_COMMUNICATION"] = "event_diagnostic_communication";
            BannersId["EVENT_DIAGNOSTIC_EMOTIONS"] = "event_diagnostic_emotions";
            BannersId["EVENT_DIAGNOSTIC_TRAVEL"] = "event_diagnostic_travel";
            BannersId["EVENT_CONSULTATION_LOVE"] = "event_consultation_love";
            BannersId["EVENT_CONSULTATION_CAREER"] = "event_consultation_career";
            BannersId["EVENT_CONSULTATION_FINANCE"] = "event_consultation_finance";
            BannersId["EVENT_CONSULTATION_HEALTH"] = "event_consultation_health";
        })(BannersId = IndiBanners.BannersId || (IndiBanners.BannersId = {}));
    })(IndiBanners = Indi.IndiBanners || (Indi.IndiBanners = {}));
    var IndiLeads;
    (function (IndiLeads) {
        var Leads;
        (function (Leads) {
            Leads["PROFILE_CONSULTATION"] = "profile_consultation";
            Leads["DIAGNOSTICS"] = "diagnostics";
        })(Leads = IndiLeads.Leads || (IndiLeads.Leads = {}));
        var Spheres;
        (function (Spheres) {
            Spheres["EMOTIONS"] = "emotions";
            Spheres["LOVE"] = "love";
            Spheres["COMMUNICATION"] = "communication";
            Spheres["CAREER"] = "career";
            Spheres["FINANCE"] = "finance";
            Spheres["HEALTH"] = "health";
            Spheres["TRAVEL"] = "travel";
        })(Spheres = IndiLeads.Spheres || (IndiLeads.Spheres = {}));
    })(IndiLeads = Indi.IndiLeads || (Indi.IndiLeads = {}));
    var WebPush;
    (function (WebPush) {
        var NotificationId;
        (function (NotificationId) {
            NotificationId["IMPORTANT_EVENT_NOTIFICATION_ID"] = "chronos.webpush.importantEvent";
            NotificationId["PROGNOSIS_REMINDER_NOTIFICATION_ID"] = "chronos.webpush.prognosisReminder";
            NotificationId["TEST_WEBPUSH_NOTIFICATION_ID"] = "TEST_WEBPUSH";
        })(NotificationId = WebPush.NotificationId || (WebPush.NotificationId = {}));
    })(WebPush = Indi.WebPush || (Indi.WebPush = {}));
})(Indi = exports.Indi || (exports.Indi = {}));
